import { Box, Button, Code, Flex, Heading } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonTooltip } from 'components/common/tooltip';
import { MachineModelsContext } from 'contexts/admin/machine-models.context';
import { getModelKeyFromModel } from 'lib_ts/classes/ms.helper';
import { RADIX } from 'lib_ts/enums/radix-ui';
import React, { useContext } from 'react';

interface IProps {
  modelID: string;
  onActivated?: (success: boolean) => void;
}

export const ActivateModelButton: React.FC<IProps> = ({
  modelID,
  onActivated,
}) => {
  const machineModelsCx = useContext(MachineModelsContext);
  const model = machineModelsCx.models.find((m) => m._id === modelID);

  if (!model) {
    return null;
  }

  const handleActivate = async () => {
    try {
      const success = await machineModelsCx.activateModel({
        modelID: model._id,
        machineID: model.machineID,
      });

      if (onActivated) {
        onActivated(success);
      }
    } catch (error) {
      console.error(error);

      if (onActivated) {
        onActivated(false);
      }
    }
  };

  return (
    <ErrorBoundary identifier="ActivateModelButton">
      <CommonTooltip
        trigger={
          <Button
            size={RADIX.BUTTON.SIZE.SM}
            color={RADIX.COLOR.SUCCESS}
            onClick={handleActivate}
          >
            Activate
          </Button>
        }
        content={
          <Flex direction="column" gap={RADIX.FLEX.GAP.SM}>
            <Heading size={RADIX.HEADING.SIZE.SM}>Click to activate</Heading>
            <Box>
              Model: <Code>{model.name}</Code>
            </Box>
            <Box>
              Machine: <Code>{model.machineID}</Code>
            </Box>
            <Box>
              Key: <Code>{getModelKeyFromModel(model)}</Code>
            </Box>
          </Flex>
        }
      />
    </ErrorBoundary>
  );
};
